module.exports = __webpack_public_path__ + "img/lb3.560070e1.svg";